import { Recipient } from './Recipient';
import { Shipper } from './Shipper';

export class AllowedStates {
  /**
   * constructor description
   * @param {Object} allowedCountries - An object.
   * @param  {Shipper} allowedCountries.shipper
  */
  constructor({ shipper, recipient }) {
    this.shipper = shipper ? new Shipper(shipper) : null;
    this.recipient = recipient ? new Recipient(recipient) : null;
  }
}
